import { render } from "./CasesFiji2.vue?vue&type=template&id=157ce890&scoped=true"
import script from "./CasesFiji2.vue?vue&type=script&lang=js"
export * from "./CasesFiji2.vue?vue&type=script&lang=js"

import "./CasesFiji2.vue?vue&type=style&index=0&id=157ce890&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157ce890"]])

export default __exports__